/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Forgot_TitleInputs */

const fr_auth_forgot_title = /** @type {(inputs: Auth_Forgot_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réinitialiser votre mot de passe`)
};

const en_auth_forgot_title = /** @type {(inputs: Auth_Forgot_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset your password`)
};

/**
* | output |
* | --- |
* | "Reset your password" |
*
* @param {Auth_Forgot_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_forgot_title = /** @type {((inputs?: Auth_Forgot_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Forgot_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_forgot_title(inputs)
	return fr_auth_forgot_title(inputs)
});